import React from 'react';

import { Card } from '@iris/react-components';
import {
    AndroidIcon,
    AppleIcon,
    ArrowRoadIcon,
    AutoHighBeamHeadlightsIcon,
    BackupCameraIcon,
    BlindSpotMonitorIcon,
    BluetoothIcon,
    BrakesIcon,
    CaptainChairIcon,
    CarFrontIcon,
    CarLanesIcon,
    CarLeavingLaneIcon,
    CarLockIcon,
    CarParkingIcon,
    CooledSeatsIcon,
    CrossTrafficAlertIcon,
    DisabilityEquippedIcon,
    DualRearWheelsIcon,
    DvdPlayerIcon,
    FifthRowSeatsIcon,
    FogLightsIcon,
    FourthRowSeatsIcon,
    FrontViewCameraIcon,
    GaugeArrowLeftIcon,
    GaugeArrowRightIcon,
    GearIcon,
    HeatedMirrorsIcon,
    HeatedSeatsIcon,
    HeatedSteeringWheelIcon,
    KeyFobStartIcon,
    KeyFobUnlockIcon,
    LedHeadlightsIcon,
    MassageSeatsIcon,
    MoonRoadIcon,
    MusicNotePhoneIcon,
    MusicNoteRadiatingIcon,
    ParkingSensorsIcon,
    PowerButtonIcon,
    PowerClosingDoorIcon,
    PowerOutletIcon,
    PremiumSeatsIcon,
    PremiumSteeringWheelIcon,
    PremiumWheelsIcon,
    RearHatchSensorIcon,
    RoofRackIcon,
    SatelliteDishIcon,
    SignalIcon,
    SnowflakeIcon,
    SnowflakeSunIcon,
    SpoilerIcon,
    StarRadiatingIcon,
    SteeringWheelControlsIcon,
    SteeringWheelIcon,
    SteeringWheelRoadIcon,
    SunIcon,
    SunroofIcon,
    TeenDriverTechIcon,
    ThirdRowSeatsIcon,
    ThreeSixtyDegreeCameraIcon,
    TowHitchIcon,
    TrafficArrowIcon,
    TrafficConeIcon,
    TrafficSignIcon,
    TruckBedCoverIcon,
    TruckBedLinerIcon,
    UsbPortsIcon,
    WifiHotspotIcon,
    WindshieldWiperRainIcon,
} from '@iris/react-icons';
import clsx from 'clsx';
import _get from 'lodash/get';

import { useDevice } from '@bonnet/core/device';

import {
    Carousel,
    Heading,
    Section,
    SubHeading,
    Text,
} from 'reaxl';

import VehicleFeaturesSheet from './VehicleFeaturesSheet';

function getCarouselHeaderIcon(tabName) {
    switch (tabName) {
        case 'highlights':
            return <StarRadiatingIcon />;
        case 'safety':
            return <TrafficConeIcon />;
        case 'technology':
            return <SignalIcon />;
        case 'interior':
            return <SteeringWheelIcon />;
        case 'exterior':
            return <CarFrontIcon />;
        case 'mechanical':
            return <GearIcon />;
        default:
            return null;
    }
}

function getFeaturesIcon(feature) {

    switch (feature) {
        case 'Disability Equipped':
            return <DisabilityEquippedIcon />;
        case '360-Degree Camera':
            return <ThreeSixtyDegreeCameraIcon />;
        case 'Front View Camera':
            return <FrontViewCameraIcon />;
        case 'Backup Camera':
            return <BackupCameraIcon />;
        case 'Blind Spot Monitor':
            return <BlindSpotMonitorIcon />;
        case 'Lane Departure Warning':
            return <CarLeavingLaneIcon />;
        case 'Cross Traffic Alert':
            return <CrossTrafficAlertIcon />;
        case 'Adaptive Cruise Control':
            return <GaugeArrowRightIcon />;
        case 'Automatic Parking':
            return <CarParkingIcon />;
        case 'Apple CarPlay':
            return <AppleIcon />;
        case 'Android Auto':
            return <AndroidIcon />;
        case 'Bluetooth, Hands-Free':
            return <BluetoothIcon />;
        case 'Navigation':
            return <TrafficArrowIcon />;
        case 'Cooled Seats':
            return <CooledSeatsIcon />;
        case 'Heated Seats':
            return <HeatedSeatsIcon />;
        case 'Leather Seats':
            return <PremiumSeatsIcon />;
        case 'Remote Engine Start':
            return <KeyFobStartIcon />;
        case 'Keyless Entry':
            return <KeyFobUnlockIcon />;
        case 'Keyless Start':
            return <PowerButtonIcon />;
        case 'Multi-zone Climate Control':
            return <SnowflakeSunIcon />;
        case 'Heated Steering Wheel':
            return <HeatedSteeringWheelIcon />;
        case 'WiFi Hotspot':
            return <WifiHotspotIcon />;
        case 'Panoramic Roof':
            return <SunIcon />;
        case 'Sunroof':
            return <SunroofIcon />;
        case 'Hands Free Lift Gate':
            return <RearHatchSensorIcon />;
        case '2nd Row Captain Chairs':
            return <CaptainChairIcon />;
        case 'Premium Audio':
            return <MusicNoteRadiatingIcon />;
        case 'LED Headlights':
            return <LedHeadlightsIcon />;
        case 'USB Ports':
            return <UsbPortsIcon />;
        case 'Portable Audio Connection':
            return <MusicNotePhoneIcon />;
        case '3rd Row Seats':
            return <ThirdRowSeatsIcon />;
        case 'Satellite Radio':
            return <SatelliteDishIcon />;
        case 'Brake Assist':
            return <BrakesIcon />;
        case 'Lane Keep Assist':
            return <CarLanesIcon />;
        case 'Night Vision':
            return <MoonRoadIcon />;
        case 'Traffic Sign Recognition':
            return <TrafficSignIcon />;
        case 'Heated Mirrors':
            return <HeatedMirrorsIcon />;
        case 'Auto High Beam Headlights':
            return <AutoHighBeamHeadlightsIcon />;
        case 'Fog Lights':
            return <FogLightsIcon />;
        case 'Parking Sensors':
            return <ParkingSensorsIcon />;
        case 'Steering Wheel Controls':
            return <SteeringWheelControlsIcon />;
        case 'Security System':
            return <CarLockIcon />;
        case 'Head-Up Display':
            return <ArrowRoadIcon />;
        case 'DVD Player':
            return <DvdPlayerIcon />;
        case 'Rear Climate Control':
            return <SnowflakeIcon />;
        case 'Trailer Hitch':
            return <TowHitchIcon />;
        case 'Roof Rack':
            return <RoofRackIcon />;
        case 'Truck Bed Liner':
            return <TruckBedLinerIcon />;
        case 'Truck Bed Cover':
            return <TruckBedCoverIcon />;
        case 'Power Closing Door':
            return <PowerClosingDoorIcon />;
        case 'Dual Rear Wheels':
            return <DualRearWheelsIcon />;
        case '115v Power Outlet':
            return <PowerOutletIcon />;
        case 'Seat Massage System':
            return <MassageSeatsIcon />;
        case 'Leather Steering Wheel':
            return <PremiumSteeringWheelIcon />;
        case '4th Row Seat':
            return <FourthRowSeatsIcon />;
        case '5th Row Seat':
            return <FifthRowSeatsIcon />;
        case 'Spoiler':
            return <SpoilerIcon />;
        case 'Autopilot':
            return <SteeringWheelRoadIcon />;
        case 'Cruise Control':
            return <GaugeArrowLeftIcon />;
        case 'Premium Wheels':
            return <PremiumWheelsIcon />;
        case 'Rain Sensing Wipers':
            return <WindshieldWiperRainIcon />;
        case 'Teen Driver Tech':
            return <TeenDriverTechIcon />;
        default:
            return null;
    }
}

/**
 * A carousel that holds cards containing the vehicle's features.
 *
 * @component
 * @param {Object} props
 * @param {Object} [props.features] - Object containing the non-ranked features used in the modal
 * @param {Object} [props.packages] - Object containing the non-ranked package features used only in the modal
 * @param {Object} [props.rankedFeatures] - Object containing the ranked features and the list items features
 * @param {string} props.sectionHeader - The header text to display above the carousel
 * @param {string} props.vehicleTitle - The title of the vehicle (will be cleaned of "New"/"Used" prefixes)
 * @returns {JSX.Element} A carousel full of vehicle features cards
 *
 */

export default function VehicleFeaturesCarousel(
    {
        features = {},
        packages = {},
        rankedFeatures = {},
        sectionHeader,
        vehicleTitle,
    }
) {
    const device = useDevice();
    const isXs = _get(device, 'is.xs', false);

    const vehicleFeaturesCards = [...Object.keys(rankedFeatures)].map((featureHeader) => (
        <Card
            className="iris:mr-4 iris:overflow-hidden"
            key={featureHeader + 'VehicleFeatureCard'}
        >
            <div
                className="margin-left-auto margin-right-auto features-card-icon"
            >
                {getCarouselHeaderIcon(featureHeader)}
            </div>

            <SubHeading
                level={3}
                className="margin-top-2 text-blue-darkest margin-left-auto margin-right-auto"
            >
                {featureHeader.charAt(0).toUpperCase() + String(featureHeader).slice(1)}
            </SubHeading>

            <Text
                size={300}
                className="padding-bottom-2"
            >
                {rankedFeatures?.[featureHeader].slice(0, 6).map((feature, index) => (
                    <div
                        key={feature + 'FeatureCardItem'}
                        className={clsx(
                            'text-align-center',
                            'display-flex',
                            'align-items-center',
                            {
                                'margin-top-5': index === 0,
                                'margin-top-4': index !== 0,
                            }
                        )}
                    >

                        <span
                            className="margin-right-3 features-card-icon-primary"
                        >
                            {getFeaturesIcon(feature)}
                        </span>
                        {feature}
                    </div>
                ))}
            </Text>
        </Card>
    ));

    return (
        <Section
            alignment="left"
            className="padding-bottom-5"
        >
            <Heading
                className={clsx(
                    'padding-bottom-2',
                    'margin-bottom-3',
                    {
                        'padding-top-5': !isXs,
                    }
                )}
                level={3}
            >
                {sectionHeader}
            </Heading>
            <Carousel
                cellWidth="300px"
                initialIndex={0}
                fullWidth
                fullHeight
                fullWidthScroll
                scrollItemsCount={1}
            >
                {
                    ...vehicleFeaturesCards
                }
            </Carousel>

            <div className="display-flex justify-content-center margin-top-5 iris:text-[var(--base-color-primary-600)] iris:font-bold">
                {/* Sheet Component Trigger inherits styles so setting font color and weight in parent div */}
                <VehicleFeaturesSheet
                    packages={packages}
                    features={features}
                    vehicleTitle={vehicleTitle}
                />
            </div>
        </Section>
    );
}
